import request from '@/utils/request'

const getUserCouponList = async function(params) {
    return request({
        url: '/api/user/cpn/userCouponList.api',
        method: 'post',
        data: params
    });
}

const userCouponAndVoucherList = async function(params) {
    return request({
        url: '/api/user/cpn/userCouponAndVoucherList.api',
        method: 'post',
        data: params
    });
}

const getUserDownloadCouponList = async function(params) {
    return request({
        url: '/api/user/cpn/downloadCouponList.api',
        method: 'post',
        data: params
    });
}

const userCouponDownload = async function(params) {
    return request({
        url: '/api/user/cpn/rgst/rgstDownloadCoupon.api',
        method: 'post',
        data: params
    });
}

const newUserCoupon = async function(params) {
    return request({
        url: '/api/user/cpn/rgst/newUserCoupon.api',
        method: 'post',
        data: params
    });
}

export {
    getUserCouponList,
    userCouponAndVoucherList,
    getUserDownloadCouponList,
    userCouponDownload,
    newUserCoupon
} 